/* tslint:disable */
/* eslint-disable */
export enum FundingResultsOrderBy {
  Id = 'Id',
  MID = 'MID',
  CreatedUtc = 'CreatedUtc',
  FundingStatus = 'FundingStatus',
  FundedDateUtc = 'FundedDateUtc'
}
